import api from "./axios";

export type Role = "agent" | "manager" | "admin" | "super_admin" | "consultant" | "dev";

export interface User {
  id: number;
  email: string;
  fullName: string;
  role: Role;
  active: boolean;
  firstLogin: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UserFilters {
  search?: string;
  role?: Role;
  active?: boolean;
  page?: number;
  pageSize?: number;
}

export interface UserStats {
  total: number;
  active: number;
  inactive: number;
  firstLogin: number;
  agents: number;
  managers: number;
  admins: number;
  superAdmins: number;
}

export interface OtpDelivery {
  emailSent: boolean;
  manualOtp?: string;
  otpExpiresAt: string;
}

export type CreatedUser = User & {
  otpDelivery: OtpDelivery;
};

export interface ResetOtpResponse {
  message: string;
  otpDelivery: OtpDelivery;
}

export interface OperationalDirectoryEntry {
  id: number;
  fullName: string;
  role: Role;
}

export const usersApi = {
  list: (filters: UserFilters = {}) =>
    api.get<{ data: User[]; total: number }>("/users", { params: filters }),
  // Manager+ directory for "Employé responsable" pickers — not the admin-only
  // /users list above, see server route comment.
  directory: () => api.get<OperationalDirectoryEntry[]>("/users/directory"),
  stats: () => api.get<UserStats>("/users/stats"),
  getById: (id: number) => api.get<User>(`/users/${id}`),
  create: (data: { email: string; fullName: string; role: Role }) =>
    api.post<CreatedUser>("/users", data),
  update: (id: number, data: { email?: string; role?: Role }) =>
    api.patch<User>(`/users/${id}`, data),
  toggleActivation: (id: number, active: boolean) =>
    api.patch<User>(`/users/${id}/activation`, { active }),
  resetOTP: (id: number) => api.post<ResetOtpResponse>(`/users/${id}/reset-otp`),
  remove: (id: number) => api.delete<User>(`/users/${id}`),
  restore: (id: number) => api.post<User>(`/users/${id}/restore`),
  trash: () => api.get<User[]>("/users/trash"),
};
